import pagesNames from "../../constants/pages-names";

const footerData = {
    rowOne : {
        title : "News",
        columns : [
            {
                image : {
                    name : "img-1.jpg",
                    alt : "",
                },
                link : {
                    text : "Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet",
                    path : pagesNames.home,
                },
                subtext : "Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet",
            },
            {
                image : {
                    name : "img-2.jpg",
                    alt : "",
                },
                link : {
                    text : "Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet",
                    path : pagesNames.home,
                },
                subtext : "Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet",
            },
        ],
        button : {
            text : "Read More",
            path : pagesNames.home,
        },
    },
    rowTwo : {
        title : "Insights",
        columns : [
            {
                image : {
                    name : "img-3.jpg",
                    alt : "",
                },
                link : {
                    text : "Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet",
                    path : pagesNames.home,
                },
                subtext : "Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet",
            },
            {
                image : {
                    name : "img-4.jpg",
                    alt : "",
                },
                link : {
                    text : "Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet",
                    path : pagesNames.home,
                },
                subtext : "Lorem ipsum dolor sit amet Lorem ipsum dolor sit amet",
            },
        ],
        button : {
            text : "Read More",
            path : pagesNames.home,
        },
    },
    sectionTwo : {
        listOne : [
            {
                text : "Our ESG Strategy",
                discription : "Go to our strategy page",
                path : pagesNames.starategy,
            },
            {
                text : "Our Commitments",
                discription : "Go to our commitments page",
                path : pagesNames.commitments,
            },
            {
                text : "Our ESG Journey",
                discription : "Go to esg journey page",
                path : pagesNames.journey,
            },
        ],
        listTow : [
            {
                text : "News",
                discription : "Go to news page",
                path : pagesNames.news,
            },
            {
                text : "Insights",
                discription : "Go to insights page",
                path : pagesNames.insight,
            },
        ],
        listThree : [
            {
                text : "Statements and Policies",
                discription : "Go to statements and Policies page",
                path : pagesNames.statements,
            },
            {
                text : "ESG Resource Hub",
                discription : "Go to ESG Resource Hub page",
                path : pagesNames.resource,
            },
        ],
        // listFour : [
        //     {
        //         text : "Download",
        //         discription : "Go to downloads page",
        //         path : pagesNames.home,
        //     },
        // ],
        listFive : [
            {
                image : {
                    name : "twitter-icon.svg",
                    description : "see our twitter account",
                    alt : "twitter icon",
                },
                path : "https://twitter.com/alawwalsab",
            },
            {
                image : {
                    name : "facebook-icon.svg",
                    description : "see our facebook page",
                    alt : "facebook icon",
                },
                path : "https://www.facebook.com/alawwalsab/",
            },
            {
                image : {
                    name : "instagram-icon.svg",
                    description : "see our instagram account",
                    alt : "instagram icon",
                },
                path : "https://www.instagram.com/alawwalsab/",
            },
            {
                image : {
                    name : "linkedin.svg",
                    description : "See our linkedin account",
                    alt : "linkedin icon",
                },
                path : "https://www.linkedin.com/company/alawwalsab"
            }
        ]
    }
}

export default footerData;